"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnServVolt = void 0;
const base_1 = require("./base");
/**
 * Voltage Pixel
 */
class AnServVolt extends base_1.AnServBase {
    static sendCustEvent(pixelId, eventName, eventProps) {
        const eventPropsNew = Object.assign({}, eventProps);
        eventPropsNew.aid = pixelId;
        eventPropsNew.sRng = Math.round(Math.random() * 100000000);
        eventPropsNew.ttp = eventName;
        const fUrl = (this.buildUrl("//tracking.voltagesearch.com/image.gif", [
            "aid", "sRng",
            "tid", "ttp", "cnt", "val", "custom0", "custom1",
            "custom2", "custom3", "custom4", "ret"
        ], eventPropsNew));
        this.renderElementImage(fUrl);
        this.logEvent({
            url: fUrl
        });
        return true;
    }
}
exports.AnServVolt = AnServVolt;
AnServVolt.serviceName = "Voltage";
